// @flow

import { SET_PAYMENTAGREEMENTS, UPDATE_PAYMENT_AGREEMENT, ADD_PAYMENTAGREEMENT } from "../actions"

const handlePaymentAgreementUpdate = ( state: any, action: any ) => {
  const newPaymentAgreementId = action.response.id
  const filteredUsers = state.filter( paymentAgreement => paymentAgreement.id !== newPaymentAgreementId )
  return [ action.response, ...filteredUsers ]
}

export default ( state: any = [], action: any ) => {
  switch ( action.type ) {
  case SET_PAYMENTAGREEMENTS:
    return action.response
  case ADD_PAYMENTAGREEMENT:
    return [ action.response, ...state ]
  case UPDATE_PAYMENT_AGREEMENT:
    return handlePaymentAgreementUpdate( state, action )
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/paymentAgreements.jsx